<template>
  <svg
    @click="$emit('click')"
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    version="1.1"
    :class="classes"
    :style="styles"
  >
    <path
      v-if="active"
      d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"
    />
    <path
      v-else
      d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
    />
  </svg>
</template>

<script>
import BaseIcon from '@/components/icons/BaseIcon'

export default {
  extends: BaseIcon,
  computed: {
    activeRotation () {
      return 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/uiColors';
@import '_baseIcon';

svg {
  &.active {
    .center {
      fill: #fff !important;
    }
  }
}
</style>
